/* Glow Glove Soft Edit theme: cart drawer, product form, quantity steppers, menu. */
(function () {
  'use strict';
  var routes = window.GG_ROUTES || { root: '/', cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
  var strings = window.GG_STRINGS || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* toast */
  var toastTimer;
  function toast(msg) {
    var t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 2400);
  }

  /* drawer */
  var lastFocus = null;
  function drawer() { return $('#CartDrawer'); }
  function openCart() {
    var d = drawer(); if (!d) { window.location.href = routes.cart_url; return; }
    lastFocus = document.activeElement;
    d.classList.add('is-on'); d.setAttribute('aria-hidden', 'false');
    $('#CartScrim').classList.add('is-on');
    var c = $('[data-cart-close]', d); if (c) c.focus();
  }
  function closeCart() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-on'); d.setAttribute('aria-hidden', 'true');
    $('#CartScrim').classList.remove('is-on');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCount(count) {
    $all('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    $all('[data-cart-button]').forEach(function (el) { el.setAttribute('aria-label', (strings.cart || 'Cart') + ', ' + count); });
  }

  function refreshDrawer() {
    return fetch(routes.root + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer']; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawerBody');
        var current = $('#CartDrawerBody');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var count = fresh ? fresh.getAttribute('data-item-count') : null;
        if (count !== null) updateCount(count);
      });
  }

  function postJSON(url, body) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok || json.status) { throw new Error(json.description || json.message || strings.error || 'Something went wrong. Please try again.'); }
        return json;
      });
    });
  }

  /* add to cart (product page + quick add on cards) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || !drawer()) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-loading'); }
    var fd = new FormData(form);
    var body = { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }] };
    postJSON(routes.cart_add_url, body)
      .then(function () { return refreshDrawer(); })
      .then(function () { toast(strings.added || 'Added to cart'); openCart(); })
      .catch(function (err) { toast(err.message); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('is-loading'); } });
  });

  /* clicks: open/close, drawer quantity, steppers, menu */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-open]')) { if (drawer()) { e.preventDefault(); openCart(); } return; }
    if (t.closest('[data-cart-close]') || t.closest('#CartScrim')) { e.preventDefault(); closeCart(); return; }

    var change = t.closest('[data-line-change]');
    if (change) {
      e.preventDefault();
      var line = Number(change.getAttribute('data-line'));
      var qty = Number(change.getAttribute('data-quantity'));
      var body = $('#CartDrawerBody'); if (body) body.classList.add('is-loading');
      postJSON(routes.cart_change_url, { line: line, quantity: qty })
        .then(function () { return refreshDrawer(); })
        .catch(function (err) { toast(err.message); })
        .finally(function () { var b = $('#CartDrawerBody'); if (b) b.classList.remove('is-loading'); });
      return;
    }

    var step = t.closest('[data-qty-step]');
    if (step) {
      var input = $('input', step.closest('.qty'));
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.getAttribute('data-qty-step')));
      if (input.max) v = Math.min(v, Number(input.max));
      input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var rail = t.closest('[data-scroll]');
    if (rail) {
      var r = document.getElementById(rail.getAttribute('data-scroll'));
      if (r) r.scrollBy({ left: Number(rail.getAttribute('data-dir')) * r.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }

    var menu = t.closest('[data-menu-toggle]');
    if (menu) {
      var nav = $('#SiteNav'); var open = nav.classList.toggle('is-open');
      menu.setAttribute('aria-expanded', open);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer() && drawer().classList.contains('is-on')) closeCart();
  });

  /* variant picker */
  $all('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    var dataEl = document.getElementById(picker.getAttribute('data-variant-picker'));
    if (!form || !dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    picker.addEventListener('change', function () {
      var selected = $all('fieldset', picker).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
      var submit = $('[type="submit"]', form);
      if (!match) { if (submit) { submit.disabled = true; submit.textContent = strings.unavailable || 'Unavailable'; } return; }
      $('input[name="id"]', form).value = match.id;
      var price = document.querySelector('[data-price]'); if (price) price.innerHTML = match.price_html;
      if (submit) { submit.disabled = !match.available; submit.textContent = match.available ? (strings.add || 'Add to cart') : (strings.sold_out || 'Sold out'); }
      var url = new URL(window.location.href); url.searchParams.set('variant', match.id); window.history.replaceState({}, '', url.toString());
    });
  });
})();
